import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { SharedProgrammingService } from './../../../common/services/shared-programming.service';
import { ProgrammingUtilsService as Utils } from '../../../common/services/utils.service';

@Component({
  selector: 'prg-select-sensor-type',
  templateUrl: './select-sensor-type.component.html',
  styleUrls: ['./select-sensor-type.component.less']
})
export class SelectSensorTypeComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private shared: SharedProgrammingService
  ) { }

  ngOnInit() {
    // this.shared.addBreadcrumb({ label: 'Sensors', route: Utils.getPathFromRoot(this.route) });
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-sensors/select-sensor-type/select-sensor-type.component.ts